import Box from '@mui/material/Box'
import { useState } from 'react'
import { VendorType } from './VendorType'
import { VendorInfo } from './VendorInfo'
import { VendorPriceRange } from './VendorPriceRange'
import { VenueMaxCapacity } from './VenueMaxCapacity'
import { VendorBusinessType } from './VendorBusinessType'
import Services from '../Services'
import Stepper from '../../atoms/Stepper/Stepper'

export const VendorOnboarding = ({
	userDetails,
	setUserDetails,
	role,
	setRole,
}) => {
	const [step, setStep] = useState(0)

	const renderStep = () => {
		switch (step) {
			case 0:
				return (
					<VendorType
						userDetails={userDetails}
						setUserDetails={setUserDetails}
						setRole={setRole}
						setStep={setStep}
					/>
				)
			case 1:
				return (
					<VendorInfo
						userDetails={userDetails}
						setUserDetails={setUserDetails}
						setStep={setStep}
					/>
				)
			case 2:
				return (
					<VendorBusinessType
						userDetails={userDetails}
						setUserDetails={setUserDetails}
						setStep={setStep}
					/>
				)
			case 3:
				return (
					<Services
						userDetails={userDetails}
						setUserDetails={setUserDetails}
						setStep={setStep}
					/>
				)
			case 4:
				return (
					<VendorPriceRange
						userDetails={userDetails}
						setUserDetails={setUserDetails}
						role={role}
						setStep={setStep}
					/>
				)
			case 5:
				return (
					<VenueMaxCapacity
						userDetails={userDetails}
						setUserDetails={setUserDetails}
						role={role}
						setStep={setStep}
					/>
				)
			default:
				return null
		}
	}

	const totalSteps = userDetails.type === 'venue' ? 6 : 5

	return (
		<div>
			{renderStep()}
			<Box
				sx={{
					width: '100%',
					marginTop: '3rem',
					bottom: '30px',
					right: 0,
					'@media (min-width:600px)': { position: 'absolute' },
				}}
			>
				<Stepper
					totalSteps={totalSteps}
					subSteps={3}
					activeStep={step + 1}
				/>
			</Box>
		</div>
	)
}
